/**
 * Tipos de torneo (tor_tipo)
 */
export const TOURNAMENT_TYPE = {
  REGULAR_ABIERTO: 1,
  REGULAR_CERRADO: 2,
  CLASIFICATORIO: 3,
  CAMPEONES: 4,
  EQUIPOS: 5,
  ASCENSO: 6,
  CLASIFICATORIO_AFICIONADOS: 7,
};

/**
 * Sistemas de torneo (tor_sistema)
 */
export const TOURNAMENT_SISTEMA = {
  SUIZO: 1,
  AMERICANO: 2,
  MATCH: 3,
};

/**
 * Ritmos de juego (tor_ritmo_juego)
 */
export const TOURNAMENT_RITMO = {
  PENSADO: 0,
  RAPIDO: 1,
  BLITZ: 2,
};

/**
 * Estados del torneo (tor_estado)
 */
export const TOURNAMENT_ESTADO = {
  CREADO: 0,
  INSCRIPCION_ABIERTA: 1,
  INSCRIPCION_CERRADA: 2,
  EN_CURSO: 3,
  FINALIZADO: 4,
  CANCELADO: 5,
};

/**
 * Software de gestión (tor_software_usado)
 */
export const TOURNAMENT_SOFTWARE = {
  MANUAL: 0,
  SWISSPERFECT: 1,
  SWISS_MANAGER: 2,
  OTRO: 3,
};

/**
 * Tipo de resultado de una partida (par_tipo_res_blancas / par_tipo_res_negras)
 */
export const MATCH_TIPO_RES = {
  NORMAL: 1,
  AUSENCIA: 2,
  BYE: 3,
};

/**
 * Resultado numérico de una partida (par_resultado_blancas / par_resultado_negras)
 */
export const MATCH_RESULTADO = {
  DERROTA: 0,
  VICTORIA: 1,
  EMPATE: 2, // También se usa para ½ punto
};

/**
 * Tipo de torneo para los criterios de desempate (TiposTieBreak.ttb_tipo_torneo)
 */
export const TIEBREAK_TIPO_TORNEO = {
  INDIVIDUAL: 1,
  EQUIPOS: 2,
};

/**
 * Tipo de puntaje para torneos por equipos (tor_tipo_puntaje)
 */
export const TOURNAMENT_TIPO_PUNTAJE = {
  MATCH_POINTS: 1,     // Puntaje primario = Match Points (2/1/0 por partido)
  INDIVIDUALES: 2,     // Puntaje primario = Puntos de tablero acumulados
};
